/* ========================================================================== *\
    Imports
/* ========================================================================== */
import { isElement } from 'lodash';

import { publish, subscribe } from '../2-utilities/event';

import { 
    START_AUTOPLAY as startAutoplay, 
    STOP_AUTOPLAY as stopAutoplay,
    QUIT_AUTOPLAY as quitAutoplay,
    RESTART_AUTOPLAY as restartAutoplay,
    AUTOPLAY_NEXT_ITEM as toNextItem
} from '../3-data/consts/eventNames'; 

/* ========================================================================== *\
    Constants
/* ========================================================================== */
const moduleName = 'autoplay',
    baseSelector = `.js-${ moduleName }`,
    selectors = {
        base: baseSelector,
        play: `${ baseSelector }-play`,
        stop: `${ baseSelector }-stop`
    },
    hideClass = '--hide',
    intervalTime = 6000;

let isAutoplay = false,
    defaultAutoplay = false,
    autoplay;

/* ========================================================================== *\
    Functionality
/* ========================================================================== */
function stop() {
    const playEl = document.querySelector(selectors.play),
        stopEl = document.querySelector(selectors.stop);

    playEl.classList.add(hideClass);
    stopEl.classList.remove(hideClass);

    clearInterval(autoplay);
}

function start() {
    const playEl = document.querySelector(selectors.play),
        stopEl = document.querySelector(selectors.stop);

    if(isAutoplay) {
        playEl.classList.remove(hideClass);
        stopEl.classList.add(hideClass);

        autoplay = setInterval(
            () => {
                publish(toNextItem)
            }, 
            intervalTime
        );
    }
}

function quit() {
    if(defaultAutoplay) {
        isAutoplay = false;

        stop();
    }
}

function restart() {
    if(defaultAutoplay) {
        isAutoplay = true;

        start();
    }
}

function toggle(event) {
    event.preventDefault();

    if(isAutoplay) {
        defaultAutoplay = false;
        isAutoplay = false;
        stop();
    } else {
        defaultAutoplay = true;
        isAutoplay = true;
        start();
    }
}

function init(baseElement = document.querySelector(selectors.base)) {
    if(!isElement(baseElement)) {
        return false;
    }

    start();
    baseElement.addEventListener('click', toggle);

    subscribe(quitAutoplay, quit);
    subscribe(stopAutoplay, stop);
    subscribe(startAutoplay, start);
    subscribe(restartAutoplay, restart);
};

init();